import {
  useCreateSensitiveConfigs,
  useDeleteSensitiveConfig,
  useGetSensitiveConfigs,
  useUpdateSensitiveConfig,
} from '@src/emp-3.0/api/queryHooks';
import { message, Spin } from 'antd';
import { noop } from 'lodash';
import React, { useEffect, useState } from 'react';
import CCSConfigurationHeader from './CCSConfigurationHeader';
import ConfigurationBlock from './ConfigurationBlock/ConfigurationBlock';
import NewConfigBlock from './NewConfigBLock/NewConfigBlock';

const SensitiveCCSConfiguration = () => {
  const [openNewConfig, setOpenNewConfig] = useState<boolean>(false);
  const [filter, setFilter] = useState<string>('');

  const { isLoading: isLoadingGetConfig, data, refetch } = useGetSensitiveConfigs(filter);
  const { mutate: createSensitiveConfig, isLoading: isLoadingCreateConfig } =
    useCreateSensitiveConfigs();
  const { mutate: updateSensitiveConfig, isLoading: isLoadingUpdateConfig } =
    useUpdateSensitiveConfig();
  const { mutate: deleteSensitiveConfig, isLoading: isLoadingDeleteConfig } =
    useDeleteSensitiveConfig();

  useEffect(() => {
    refetch();
  }, [filter, refetch]);

  const handleUpdate = (payload) => {
    updateSensitiveConfig(
      { payload },
      {
        onSuccess: () => {
          message.success('Update Success!');
        },
        onError: (error: any) => {
          message.error(error?.response?.data?.msg);
        },
      },
    );
  };

  const handleCreateNew = (payload) => {
    createSensitiveConfig(
      { payload },
      {
        onSuccess: () => {
          message.success('Create Success!');
          setOpenNewConfig(false);
        },
        onError: (error: any) => {
          message.error(error?.response?.data?.msg);
        },
      },
    );
  };

  const handleDelete = (payload) => {
    deleteSensitiveConfig(
      { payload },
      {
        onSuccess: () => {
          message.success('Delete Success!');
        },
        onError: (error: any) => {
          message.error(error?.response?.data?.msg);
        },
      },
    );
  };

  const addNewConfig = () => {
    setOpenNewConfig(true);
  };

  return (
    <Spin
      spinning={
        isLoadingGetConfig ||
        isLoadingCreateConfig ||
        isLoadingUpdateConfig ||
        isLoadingDeleteConfig
      }
    >
      <div>
        <CCSConfigurationHeader
          addNewConfig={addNewConfig}
          setFilter={setFilter}
          openNewConfig={openNewConfig}
        ></CCSConfigurationHeader>
      </div>
      {data &&
        data.map((block, i) => (
          <ConfigurationBlock
            key={block.config_id}
            data={block}
            refetch={noop}
            handleUpdate={handleUpdate}
            height={'430px'}
            showDelete={true}
            handleDelete={handleDelete}
          />
        ))}

      {openNewConfig && (
        <NewConfigBlock
          handleCreateNew={handleCreateNew}
          setOpenNewConfig={setOpenNewConfig}
          allConfig={data}
        />
      )}
    </Spin>
  );
};

export default SensitiveCCSConfiguration;
